export default __webpack_public_path__ + "static/media/Vector.9331ac0f.png";